<template>
    <div>
        <!-- responsive-header -->
        <responsive-header-component></responsive-header-component>
        <div class="wrapper default shopping-page">
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <navbar3-component></navbar3-component>
            </header>
            <!-- header-shopping -->
            <!-- header-shopping -->
            <header class="header-shopping default">
                <div class="container">
                    <div class="row">
                        <div class="col-12 text-center pt-2">
                            <div class="header-shopping-logo default">
                                <!--<a href="#">
                                    <img style="width:150px" src="/assets/img/logo.png" alt="">
                                </a>-->
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <ul class="checkout-steps">
                                <li>
                                    <a class="active" title="انتخاب آدرس">
                                        <span>انتخاب آدرس</span>
                                    </a>
                                </li>
                                <li class="active">
                                    <a class="active" title="مشاهده صورت حساب">
                                        <span>مشاهده صورت حساب</span>
                                    </a>
                                </li>
                                <li>
                                    <a title="اتمام خرید و ارسال">
                                        <span>اتمام خرید و ارسال</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
            <!-- header-shopping -->
            <!-- main-shopping -->
            <main class="cart-page default">
                <div class="container" v-if="baseInfo != null">
                    <div class="row">
                        <div class="cart-page-content col-xl-9 col-lg-8 col-md-12 ">
                            <section class="page-content default col-xl-12 col-lg-12 col-md-12">
                                <div class="store-address">
                                    <span class="title">آدرس فروشگاه</span>
                                    <span class="text">{{ baseInfo.Address }}</span>
                                    <div>
                                        <router-link class="btn-redirect-page" to="/">بازگشت به صفحه اصلی</router-link>
                                    </div>
                                </div>
                                <hr />
                                <div class="row ">
                                    <div class="delivery-request col-xl-12 col-lg-12 col-md-12 ">
                                        <div class="col-xl-6 col-lg-6 col-md-6 requset1">
                                            <div class="title"> <span>آدرس ارسال سفارش</span></div>
                                            <div class="text"> <span>{{cartInvoice.SendOrderAddress}}</span></div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 requset1">
                                            <div class="title"> <span>نحوه ارسال سفارش</span></div>
                                            <div v-if="cartInvoice.Carrier == null" class="text"> <span>{{cartInvoice.SendOrderMethod}}</span></div>
                                            <div v-else class="checkout-time-table checkout-time-table-time">
                                                <img :src="cartInvoice.Carrier.IconPath" @error="imageLoadOnError" />
                                                <div>
                                                    <div class="checkout-time-table-title-bar checkout-time-table-title-bar-city">
                                                        <span>{{cartInvoice.Carrier.Name}}</span>
                                                    </div>
                                                    <ul class="checkout-time-table-subtitle-bar">
                                                        <li>{{cartInvoice.SendOrderMethod}}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div class="row">
                                    <div class="title-payment col-xl-12 col-lg-12 col-md-12">
                                        <div class="payment">
                                            <label> <i class="now-ui-icons shopping_credit-card"></i></label>
                                            <div class="title"> <span>پرداخت آنلاین</span></div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row div-pardakht">
                                    <div class="getway-content col-xl-12 col-lg-12 col-md-12">
                                        <div class="col-xl-12 col-lg-12 col-md-12 payment">
                                            <span class="title">مبلغ قابل پرداخت : </span>
                                            <span class="price">{{cartInvoice.AmountPayable | formatNumber}} تومان</span>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 useCredit">
                                            <div class="form-account-agree" v-if="cartInvoice.Balance != 0">
                                                <label class="checkbox-form checkbox-primary">
                                                    <input type="checkbox" v-model="isUseCredit" id="agree" @change="calculateAmountPaybale">
                                                    <span class="checkbox-check"></span>
                                                </label>
                                                <label class="title" for="agree">موجودی کیف پول : </label>
                                                <span> {{cartInvoice.Balance | formatNumber}} تومان</span>
                                            </div>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 payment" v-if="cartInvoice.Balance != 0">
                                            <span class="title">مبلغ ارسالی به بانک : </span>
                                            <span class="price">{{ finalAmountPayable | formatNumber }} تومان</span>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12">
                                            <div class="form-account-agree">
                                                <label class="checkbox-form checkbox-primary">
                                                    <input type="checkbox" v-model="isDisabled">
                                                    <span class="checkbox-check"></span>
                                                </label>
                                                <label for="agree">
                                                    <router-link to="/rules" target="_blank" class="btn-link-border"> قوانین و مقررات</router-link>  را می پذیرم.
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 bank-pay">
                                            <div class="row">
                                                <div v-if="baseInfo != null && baseInfo.IsActiveMellatBank" class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                                    <div class="dargah radio dargah-box">
                                                        <img src="/assets/img/mellat.jpg" />
                                                        <input id="mellatBank" name="gatway" type="radio" value="3" v-model="gatwayType" />
                                                        <label class="lbl-dargah" for="mellatBank">درگاه بانک ملت</label>
                                                    </div>
                                                </div>
                                                <div v-if="baseInfo != null && baseInfo.IsActiveSamanKish" class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                                    <div class="dargah radio dargah-box">
                                                        <img src="/assets/img/kish.png" />
                                                        <input id="samankish" name="gatway" type="radio" value="1" v-model="gatwayType" />
                                                        <label class="lbl-dargah" for="samankish">درگاه سامان کیش</label>
                                                    </div>
                                                </div>
                                                <div v-if="baseInfo != null && baseInfo.IsActiveZarinPal" class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                                    <div class="dargah radio dargah-box">
                                                        <img src="/assets/img/ZarinPal.jpg" />
                                                        <input id="zarinpal" name="gatway" type="radio" value="2" v-model="gatwayType" />
                                                        <label class="lbl-dargah" for="zarinpal">درگاه زرین پال</label>
                                                    </div>
                                                </div>
                                                <div v-if="baseInfo != null && baseInfo.IsActiveSepehr" class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                                    <div class="dargah radio dargah-box">
                                                        <img src="/assets/img/saderat.png" style="width:100px;" />
                                                        <input id="saderat" name="gatway" type="radio" value="5" v-model="gatwayType" />
                                                        <label class="lbl-dargah" for="saderat">صادرات</label>
                                                    </div>
                                                </div>
                                            
                                            </div>

                                        </div>
                                        <div :class="{'col-xl-12':true, 'col-lg-12':true, 'col-md-12':true, 'btn-sub':true, 'content-loader':isShowLoader}">
                                            <input @click="redirectToBank" :class="{'btn':true, 'btn-defalt':true, 'disadledbtn':!isDisabled}" :disabled="!isDisabled" type="submit" value="پرداخت آنلاین" />
                                            <div class="div-loader">
                                                <img class="imgloader" src="/assets/img/loader/loader.svg" />
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:30%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
                                </div>
                                <products-compact></products-compact>
                            </section>

                        </div>
                        <aside class="cart-page-aside col-xl-3 col-lg-4 col-md-6 center-section order-2">
                            <div class="checkout-aside">
                                <cart-summary></cart-summary>
                            </div>
                        </aside>
                    </div>
                </div>

            </main>
            <!-- main-shopping -->
            <!-- footer -->
            <footer-component></footer-component>
            <!-- footer -->
        </div>

    </div>
</template>

<script>
    import cartSummary from "../cartComponents/cartSummary.vue"
    import { httpPromise } from "../../module/httpUtility";
    import productsCompact from "../cartComponents/productsCompact.vue"

    export default {
        data() {
            return {
                cartInvoice: {},
                isUseCredit: false,
                finalAmountPayable: 0,
                isDisabled: true,
                isShowLoader: false,
                isShowSppiner: false,
                gatwayType: 2
            }
        },
        components: {
            'cart-summary': cartSummary,
            'products-compact': productsCompact,
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-photo.svg";
            },
            calculateAmountPaybale() {
                if (this.isUseCredit) {
                    this.finalAmountPayable = ((this.cartInvoice.AmountPayable - this.cartInvoice.Balance) <= 0) ? 0 : this.cartInvoice.AmountPayable - this.cartInvoice.Balance;
                } else {
                    this.finalAmountPayable = this.cartInvoice.AmountPayable
                }
            },
            redirectToBank() {
                if (parseInt(this.gatwayType) == 0) {
                    toastr.remove();
                    toastr.error('درگاه بانکی را انتخاب کنید');
                    return;
                }
                this.isShowLoader = true;
                var url = '';
                if (parseInt(this.gatwayType) == 1) {
                    url = '/v1/Orders/SamanKishOrderPayment/GetBankPaymentUrl/';
                }
                if (parseInt(this.gatwayType) == 2) {
                    url = '/v1/Orders/ZarinPalOrderPayment/GetBankPaymentUrl/';
                }
                if (parseInt(this.gatwayType) == 3) {
                    url = '/v1/Orders/MellatBankOrderPayment/GetBankPaymentUrl/';
                }
                if (parseInt(this.gatwayType) == 5) {
                    url = '/v1/Orders/SepehrOrderPayment/GetBankPaymentUrl/';
                }
                httpPromise(this, url, 'get', { HashCartId: localStorage.getItem('CartHashId'), UseCredit: this.isUseCredit },
                    response => {
                        toastr.remove();
                        window.location.href = response.data.Value.PaymentUrl;
                        this.isShowLoader = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowLoader = false;
                    });
            },
            scrollTop() {
                $(function () {
                    $('html, body').scrollTop(0);
                });
            }
        },

        beforeMount() {
            createPageTitle('صورت حساب');
            if (this.cart == null || (this.baseInfo != null && this.baseInfo.MinimumOrders != 0 && this.cart.CartInfo.SubTotalAmount < this.baseInfo.MinimumOrders))
                this.$router.push('/cart');
            this.isShowSppiner = true;
            httpPromise(this, '/v1/Orders/CartInvoice/Read', 'get', { HashCartId: localStorage.getItem('CartHashId') },
                response => {
                    toastr.remove();
                    this.cartInvoice = response.data.Value;
                    this.calculateAmountPaybale();
                    this.isShowSppiner = false;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                    this.isShowSppiner = false;
                });
            this.scrollTop();
        },
    }
</script>

<style scoped>
    .dargah-box {
        border: 2px solid #00bfd6;
        border-radius: 7px;
        padding: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .bank-pay .radio input[type="radio"]:checked + label::after {
        width: 12px;
        height: 12px;
        top: 9px;
        right: -14px;
        opacity: 1;
        background-color: #00bfd6;
        border: 0;
    }

    .bank-pay .radio label::before, .bank-pay .radio label::after {
        width: 18px;
        height: 18px;
        border: 1px solid #6F6F6F;
        right: -17px;
        top: 6px;
    }

    .lbl-dargah {
        padding-right: 7px;
    }

    .dargah img {
        /*        width: 200px;*/
        margin-bottom: 20px;
    }

    .shopping-page .checkout-time-table {
        padding: 0px 18px 0 18px;
        margin-top: 10px;
        width: 100%;
    }

    .checkout-time-table img {
        width: 90px;
        height: 90px;
        margin-left: 18px;
        border: 1px solid #ddd;
        padding: 8px;
    }

    .content-loader {
        position: relative;
    }

    .btn-sub .div-loader {
        position: absolute;
        display: none;
    }

    .content-loader .div-loader {
        position: absolute;
        background-color: #eedfdf;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
    }

        .content-loader .div-loader img {
            width: 45px;
        }

    .store-address {
        position: relative;
    }

        .store-address .btn-redirect-page {
            position: absolute;
            top: -48px;
            left: 0;
            border-bottom: 1px dashed #1ca2bd;
            margin-top: 10px;
            display: inline-block;
            border-radius: 5px;
            color: #1ca2bd;
            transition: all .3s;
            padding: 6px;
            font-size: 12px;
            z-index: 9;
        }

    .shopping-page header.header-shopping .checkout-steps li a {
        display: inline-block;
        height: 20px;
    }

    .cart-page .checkout-aside {
        margin-top: 40px;
    }

    .disadledbtn {
        background-color: #ddd !important;
        cursor: not-allowed !important;
    }

        .disadledbtn:hover {
            background-color: #ddd !important;
            box-shadow: none;
        }

    .cart-page-content .page-content .store-address .title {
        margin-bottom: 4px;
        display: block;
    }

    .cart-page-content .page-content .store-address,
    .cart-page-content .page-content .delivery-request,
    .cart-page-content .page-content .title-payment {
        padding: 10px;
    }

        .cart-page-content .page-content .delivery-request .requset1 .tilte span {
            font-weight: 700;
            font-size: 15px;
        }

        .cart-page-content .page-content .delivery-request .requset1 .text span, .cart-page-content .page-content .store-address .text {
            color: #666;
            padding-right: 15px;
            display: inline-block;
            margin-bottom: 20px;
        }

        .cart-page-content .page-content .store-address .text {
            color: #666;
            padding-right: 15px;
            display: inline-block;
        }

    .page-content {
        background-color: #fff;
        margin-top: 15px;
    }

    .cart-page-content .page-content .title-payment i {
        vertical-align: middle;
        color: #777;
        font-size: 25px;
    }

    .cart-page-content .page-content .title-payment .title {
        display: inline-block;
        margin-right: 10px;
    }

    .getway-content {
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 7px;
    }

    .cart-page-content .page-content .getway-content .payment {
        margin-bottom: 16px;
    }

    .cart-page-content .page-content .div-pardakht {
        padding: 0 20px 20px 20px;
    }

    .cart-page-content .page-content .form-account-agree .checkbox-form {
        position: absolute;
        right: 0;
        top: 13px;
    }

    .cart-page-content .page-content .btn-sub {
        text-align: center;
    }

        .cart-page-content .page-content .btn-sub .btn {
            background-color: #1cb66e;
            color: #fff;
            width: 100%;
            font-size: 15px;
        }

    .cart-page-content .page-content .title-payment .payment {
        padding: 10px;
    }

    .page-content {
        background-color: #fff;
        margin-top: 40px;
    }

    @media only screen and (min-width: 1077px) {
        .header-shopping {
            margin-top: 20px;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .shopping-page header.header-shopping .checkout-steps li a.active::after {
            bottom: -23px;
        }

        .store-address .btn-redirect-page {
            position: absolute;
            top: -45px;
            left: 0;
            border-bottom: 1px dashed #1ca2bd;
            margin-top: 12px;
            display: inline-block;
            border-radius: 5px;
            color: #1ca2bd;
            -webkit-transition: all .3s;
            transition: all .3s;
            padding: 4px;
            font-size: 12px;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 394px) {
        .shopping-page header.header-shopping .checkout-steps li a.active:after {
            bottom: -42px;
        }
    }
</style>